(function () {
  angular.module('leanlaw').factory('apiCache', ['leanLawApi', function (leanLawApi) {
    let cache = {};
    async function call(fn, parameters, cacheKey) {
      if (!cacheKey) {
        return leanLawApi[fn](parameters);
      }
      const parametersJson = JSON.stringify(parameters);
      if (cache[cacheKey]) {
        const {
          key,
          result
        } = cache[cacheKey];
        if (key === parametersJson) {
          console.log('HIT', cacheKey);
          return result;
        }
      }
      console.log('MISS', cacheKey);
      const result = await leanLawApi[fn](parameters);
      if (!result) {
        return undefined;
      }
      cache[cacheKey] = {
        key: parametersJson,
        result
      };
      return result;
    }
    function clear(cacheKey) {
      if (cacheKey) {
        console.log('CLEAR', cacheKey);
        cache[cacheKey] = undefined;
      } else {
        console.log('CLEAR ALL');
        cache = {};
      }
    }
    return {
      call,
      clear
    };
  }]);
})();